import react from "react";
import auxJack from "../assets/mobileService/AUX JACK.png";
import backBanel from "../assets/mobileService/BACK PANEL.png";
import battery from "../assets/mobileService/BATTERY.png";
import chargingJack from "../assets/mobileService/CHARGING JACK.png";
import camera from "../assets/mobileService/FRONT CAMERA.png";
import screen from "../assets/mobileService/SCREEN.png";
import mic from "../assets/mobileService/MIC.png";
import motherBoard from "../assets/mobileService/Motherboard Inspection charges.png";
import proximitySensor from "../assets/mobileService/PROXIMITY SENSOR.png";
import receiver from "../assets/mobileService/RECEIVER.png";
import speaker from "../assets/mobileService/SPEAKER.png";
import { toast } from 'react-hot-toast';
import { PiChatTextDuotone } from "react-icons/pi";
const RepaiService = () => {

    const services = [
        {
            name: "SCREEN",
            image: screen,
        },
        {
            name: "BATTERY",
            image: battery,
        },
        {
            name: "MIC",
            image: mic,
        },
        {
            name: "RECEIVER",
            image: receiver,
        },
        {
            name: "CHARGING JACK",
            image: chargingJack,
        },
        {
            name: "SPEAKER",
            image: speaker,
        },
        {
            name: "BACK PANEL",
            image: backBanel,
        },
        {
            name: "PROXIMITY SENSOR",
            image: proximitySensor,
        },
        {
            name: "AUX JACK",
            image: auxJack,
        },
        {
            name: "FRONT CAMERA",
            image: camera,
        },
        {
            name: "BACK CAMERA",
            image: camera,
        },
        {
            name: "LCD Screen(Without Fingerprint Sensor)",
            image: screen,
        },
        {
            name: "Motherboard Inspection charges",
            image: motherBoard,
        },
        {
            name: "Mobile Cleaning Service",
            image: null,
        },
    ]
        const handleAlert = () => {
        toast.error("The Online Services Currently Unavailable, Please visit or contact our store ");
        toast("Clear Your Queries By Chatting With Our Expert Team", {
            icon: <PiChatTextDuotone className="text-[#42C8B7]" size={24} />,
            duration: 10000,
        });
    }
    return (
        <div id="repairService" className="w-full max-w-6xl mx-auto group mb-4 lg:mt-10 px-4 sm:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-start">Repair Service</h2>
            <div className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-6 mt-10">
                {services.map((service, index) => (
                    <div key={index} className="flex flex-col items-center justify-center shadow-lg px-4 py-4 md:py-8 rounded-lg" onClick={handleAlert}>
                        {service.image ? (<img src={service.image} alt={service.name} />) : null}
                        <p className="text-[10px] md:text-xs font-semibold mt-3 text-center">{service.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RepaiService;
